import ReferenceNumberTypes from 'constants/ReferenceNumberTypes';
import { PICKUP, DELIVER } from 'constants/StopActions';

export const determineReferenceNumberEntityTypes = (page, stop = null) => {
  const { BOOKING, STOPS, STOP_PICKUP, STOP_DELIVERY, ORDER, SHIPMENT_DETAILS, SHIPMENT_ROUTE } = REFERENCE_NUMBER_PAGES;
  const { BOOKING_TIME, PRIOR_TO_DELIVERY, PRIOR_TO_PICKUP, PRIOR_TO_INVOICING } = REFERENCE_NUMBER_REQUIRED_AT_STAGES;
  switch (page) {
    case BOOKING:
      return BOOKING_TIME;
    case STOP_PICKUP:
      return PRIOR_TO_PICKUP;
    case STOP_DELIVERY:
      return PRIOR_TO_DELIVERY;
    case STOPS:
      return (stop === PICKUP) ? PRIOR_TO_PICKUP : PRIOR_TO_DELIVERY;
    case ORDER:
      return null;
    case SHIPMENT_DETAILS:
      return null;
    case SHIPMENT_ROUTE:
      return (stop === PICKUP) ? PRIOR_TO_PICKUP : PRIOR_TO_DELIVERY;
    default:
      return null;
  }
}

const REFERENCE_NUMBER_PAGES = {
  BOOKING: 'Booking',
  STOPS: 'Stops',
  STOP_PICKUP: 'Stop_Pickup',
  STOP_DELIVERY: 'Stop_Delivery',
  ORDER: 'Orders',
  SHIPMENT_DETAILS: 'ShipmentDetails',
  SHIPMENT_ROUTE: 'ShipmentRoute',
};

const REFERENCE_NUMBER_REQUIRED_AT_STAGES = {
  "BOOKING_TIME": "BOOKING_TIME",
  "PRIOR_TO_PICKUP": "PRIOR_TO_PICKUP",
  "PRIOR_TO_DELIVERY": "PRIOR_TO_DELIVERY",
  "PRIOR_TO_INVOICING": "PRIOR_TO_INVOICING"
};

export const mapUserSpecificReferenceNumbers = (requiredRefs = []) => {
  return ReferenceNumberTypes.filter(Ref => {
    return requiredRefs.find(r => r.reference_number === Ref.name);
  });
};